import { Button, ITheme, useTheme } from '@mui/material';
import React from 'react';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { useNavigate } from 'react-router-dom';

export interface IBackButtonProps{
    disabled?: boolean;
    to?: string;
}

const BackButton: React.FC<IBackButtonProps> = ({ disabled, to }) => {
    const theme = useTheme() as ITheme;
    const navigate = useNavigate();
    const onClick = () => {
        if (to !== undefined){
            navigate(to);
        }else{
            navigate(-1);
        }
    }

    return <Button onClick={onClick} disabled={disabled} startIcon={<NavigateBeforeIcon />} sx={{ backgroundColor: theme.palette.common.white, color: theme.palette.primary.dark, textTransform: "none", padding:"12px" }}>Back</Button>
}

export default BackButton;